import PropTypes from 'prop-types'

export const includeSliderContentPropType = PropTypes.shape({
  altContent: PropTypes.bool,
  marginLeft: PropTypes.string,
  position: PropTypes.string,
  width: PropTypes.string,
  content: PropTypes.node,
})

export const markedValuesPropType = PropTypes.shape({
  description: { text: PropTypes.string, a11yPrefix: PropTypes.string, a11yPostfix: PropTypes.string },
  marks: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.number, label: PropTypes.string })),
})
